import { render } from "./IconBlocked.vue?vue&type=template&id=0bdad675"
import script from "./IconBlocked.vue?vue&type=script&lang=js"
export * from "./IconBlocked.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__